import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  errorMessage,
  infoMessage,
  successMessage,
} from "../../../utils/helper";
import { editTemplatesStoreApi } from "../api/TemplatesApi";
import { useStoreKeys } from "../../Recipe/hooks/useStoreKeys";
import { useNavigate } from "react-router-dom";

export const useAssignedStoreTemplateUpdateQueries = ({
  setAssignedStoreState,
  templateId,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { storeKeys } = useStoreKeys();
  const updateTemplateStore = useMutation({
    mutationFn: editTemplatesStoreApi,
    onError: (error) => {
      errorMessage(error.response.data.message);
    },

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: storeKeys.list(),
      });
      if (_.data.chartRunStatus === 1) {
        infoMessage(
          "Store(s) assigned and it will be updated to the production chart in 10 minutes."
        );
      } else {
        successMessage("Store(s) assigned.");
      }
      setAssignedStoreState((draft) => {
        draft.isLoading = false;
      });
      variables.handleModal("store-dialog-add", false);
      navigate(`/templates/details/${templateId}?stores`);
    },
  });
  return { updateTemplateStore };
};
